import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UnitsService {

    baseUrl = `${environment.apis.base}/unidades`;

    constructor(private readonly http: HttpClient) { }

    datatable(page?: number): Observable<Object> {
        let url = this.baseUrl;

        if (typeof page === 'number') {
            url += `?page=${page}`;
        }
        return this.http.get<any>(url);
    }

    getUnits(): Observable<Object> {
        let url = this.baseUrl;

        url += `/getUnits`;

        return this.http.get<any>(url);
    }

    show(id: number): Observable<Object> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.get<any>(url);
    }

    createOrUpdate(data: FormGroup, id?: number): Observable<Object> {
        let url = this.baseUrl;

        if (id) {
            url += `/${id}`;
        }

        return this.http.post<any>(url, data.value);
    }

    delete(id: number): Observable<Object> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.delete<any>(url);
    }
}
